import { useState } from "react";
import {
  Text,
  Paper,
  Group,
  Stack,
  Textarea,
  TextInput,
  Button,
} from "@mantine/core";
import { createApiKey } from "../api";
import CopyTextActionIcon from "../Playground/CopyTextActionIcon";
import { useForm } from "@mantine/form";

export function ApiShowKeyDialog({ newKey }) {
  return (
    <Paper mt="md">
      <Stack>
        <Text>Your new API key is:</Text>

        <Group>
          <Textarea
            style={{ flex: 1 }}
            readOnly
            value={newKey.token}
            autosize
            minRows={2}
            maxRows={8}
          />
          <CopyTextActionIcon text={newKey.token} />
        </Group>

        <Text mt="md" fw={600}>
          This key can't be shown again! Please copy this to a secure location.
          Do not share the key with anybody, it gives full access to your
          account!
        </Text>
      </Stack>
    </Paper>
  );
}

export function ApiKeyCreateForm({ keyAdded }) {
  const [newKey, setNewKey] = useState(null);

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      name: "",
      isUserToken: false,
    },
  });

  if (newKey) return <ApiShowKeyDialog newKey={newKey} />;

  return (
    <form
      onSubmit={form.onSubmit((values) => {
        createApiKey(values).then((data) => {
          setNewKey(data);
          keyAdded({ ...data, token: null });
        });
      })}
    >
      <Stack>
        <TextInput
          my="sm"
          label="Name"
          description="An optional name for you to tell keys apart"
          placeholder="My testing key"
          {...form.getInputProps("name")}
          radius="md"
        />

        {/* <Checkbox
          label="User bound?"
          description="An API token usually isn't tied to a specific user. However, you can optionally assign this token to your user account for statistics purposes"
          {...form.getInputProps("isUserToken")}
        /> */}

        <Button type="submit">Create</Button>
      </Stack>
    </form>
  );
}
